import React from "react";
import "./Loading.scss";

const Loading = () => (
  <div className="advance-loading">
    <i className="fa fa-spin fa-4x fa-refresh advance-loading-icon" />
  </div>
);

export default Loading;
